export default __webpack_public_path__ + "static/media/download.c5520360.svg";